// Resolves contexts chained off another context's oneEntity field ({ sourceContext, sourceField }) on every read,
// so a chain whose source was empty at mount (no channel picked yet) follows the field once it is set.
// lookup(name) finds a source outside `contexts`; readField(entityType, pk, field, appName) reads the engine store.

function pkIsComplete(pk) {
  return Boolean(pk) && typeof pk === "object" && Object.keys(pk).length > 0
    && Object.values(pk).every(value => value !== null && value !== undefined && value !== "");
}

function pkFromEntityRef(value) {
  const pk = value?.pk ?? value?.entityPk ?? value;
  if (pk && typeof pk === "object") {
    return pkIsComplete(pk) ? { ...pk } : null;
  }
  return typeof pk === "number" ? { id: pk } : null;
}

export function resolveChainedContexts(contexts, lookup, readField) {
  const resolved = {};
  const resolve = (name, seen) => {
    if (Object.prototype.hasOwnProperty.call(resolved, name)) {
      return resolved[name];
    }
    const entry = contexts[name] ?? lookup(name);
    if (!entry || typeof entry !== "object" || !entry.sourceContext || !entry.sourceField || seen.has(name)) {
      return entry ?? null;
    }
    const source = resolve(entry.sourceContext, new Set([...seen, name]));
    if (!source?.entityType || !pkIsComplete(source.entityPkUrlVars)) {
      return entry;
    }
    let value;
    try {
      value = readField(source.entityType, source.entityPkUrlVars, entry.sourceField, source.appName ?? entry.appName ?? null);
    } catch {
      return entry;
    }
    const pk = pkFromEntityRef(value);
    return pk ? { ...entry, entityPkUrlVars: pk } : entry;
  };
  Object.keys(contexts).forEach(name => {
    resolved[name] = resolve(name, new Set());
  });
  return resolved;
}
